(ns hai.library.connections.common
  "Shared helpers for the connections views (table, card)."
  (:require
   [hai.ui.icons :as icons]))

(def type->icon
  "Maps `:connection/type` to its brand icon component. Add entries as
   new connection types ship — falling back to nil renders no icon."
  {:airtable        icons/airtable
   :notion          icons/notion
   :hubspot         icons/hubspot
   :github          icons/github
   :linear          icons/linear
   :google-calendar icons/google-calendar
   :outlook-calendar icons/outlook-calendar
   :google          icons/google
   :slack           icons/slack
   :salesforce      icons/salesforce
   :database        icons/database-generic
   :jdbc            icons/database-generic})
